// extracted by mini-css-extract-plugin
export default {"container":"CmsLayout-container-N87"};